/* eslint-disable max-len */
import React, { useState, useContext } from 'react';
import { sendRequest } from '../../api/shootAPI';
import API from '../../api/endpoints';
import { NotificationContext } from '../../contexts/Notification';
import { UserContext } from '../../contexts/User';
import TimeoffActivePanel from './TimeoffActivePanel';
import TimeoffArchivePanel from './TimeoffArchivePanel';

const TABS = ['Active', 'Archived'];

function TimeoffPolicyPanel() {
  const [value, setValue] = useState(0);
  const [policies, setPolicies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { displayNotification } = useContext(NotificationContext);
  const { activeWorkspace } = useContext(UserContext);

  const getPolicies = async () => {
    setIsLoading(true);
    const res = await sendRequest({ method: 'get', url: API.WORKSPACE.offTimePolicies(activeWorkspace.id) });
    if (res.success) {
      setPolicies(res.data.ptoPolicies);
    } else {
      displayNotification({ message: 'An error occurs while fetching PTO policies.', severity: 'error' });
    }
    setIsLoading(false);
  };

  return (
    <div>
      <div className="flex items-center gap-1 px-4 pt-3 border-b border-rule" style={{ borderBottomStyle: 'solid' }}>
        {TABS.map((label, i) => {
          const active = value === i;
          return (
            <button
              key={label}
              type="button"
              onClick={() => setValue(i)}
              className={`relative inline-flex items-center px-3 py-2 text-sm bg-transparent border-0 cursor-pointer transition ${active ? 'text-brand-700 font-semibold' : 'text-ink-500 font-medium hover:text-ink-900'}`}
            >
              {label}
              {active && <span className="absolute left-3 right-3 bottom-0" style={{ height: 2, background: '#315285', borderRadius: 2 }} />}
            </button>
          );
        })}
      </div>
      {value === 0
        ? <TimeoffActivePanel isLoading={isLoading} policies={policies} getPolicies={getPolicies} />
        : <TimeoffArchivePanel isLoading={isLoading} policies={policies} getPolicies={getPolicies} />}
    </div>
  );
}

export default TimeoffPolicyPanel;
